import SaleModal from "./SaleModal";

export default SaleModal;
